import React from 'react';
import { FormLayout, Select } from '../../components/ui';
import { LANGUAGES, LANGUAGE_NAMES, DEFAULT_LANGUAGE } from '../../utils/languages';
import type { SettingsSectionProps } from './SettingsPage';

// The language the sign-in screen opens in. The whole app is translated by
// Google Translate from the language chosen at sign-in, so this is the one
// most of your users will end up reading.

const LanguageSection = ({ form, setForm, saving, onSubmit, t }: SettingsSectionProps) => (
  <FormLayout
    title="Language"
    submitLabel="💾 Save Language"
    submitting={saving}
    onSubmit={onSubmit}
  >
    <p style={{ color: t.textMuted, fontSize: t.fontSize.md, margin: '0 0 14px' }}>
      Pre-selected on the sign-in screen for everyone. A user can still pick
      another language before signing in; the app is translated in that language
      for their session.
    </p>
    <FormLayout.Grid columns={2}>
      <Select
        label="Default language" placeholder=""
        value={form.defaultLanguage || DEFAULT_LANGUAGE}
        onChange={(e) => setForm({ ...form, defaultLanguage: e.target.value })}
        options={LANGUAGE_NAMES.map((name) => ({ value: name, label: LANGUAGES[name].nativeName }))}
      />
    </FormLayout.Grid>
  </FormLayout>
);

export default LanguageSection;
